import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Card, Field, goldBtn } from "@/manager/ui";

function Section({ title, enabled, onToggle, children, testid }) {
  return (
    <Card className="p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-display text-lg">{title}</h3>
        {onToggle && <label className="flex items-center gap-2 text-xs text-[#6b6a66]">Contratado <Switch checked={!!enabled} onCheckedChange={onToggle} data-testid={`svc-${testid}-enabled`} /></label>}
      </div>
      {(enabled || !onToggle) && <div className="grid grid-cols-1 md:grid-cols-2 gap-3">{children}</div>}
    </Card>
  );
}

export default function ServicesTab({ ev, save }) {
  const [s, setS] = useState(ev.services);
  const [x, setX] = useState(ev.external);
  useEffect(() => { setS(ev.services); setX(ev.external); }, [ev]);
  const up = (svc, k, v) => setS({ ...s, [svc]: { ...s[svc], [k]: v } });
  const inp = (svc, k, props = {}) => (
    <Input value={s[svc][k] ?? ""} onChange={(e) => up(svc, k, props.type === "number" ? (e.target.value === "" ? null : Number(e.target.value)) : e.target.value)} data-testid={`svc-${svc}-${k}`} {...props} />
  );
  const confirm = (svc) => (
    <label className="flex items-center gap-2 text-sm"><Switch checked={!!s[svc].confirmed} onCheckedChange={(v) => up(svc, "confirmed", v)} data-testid={`svc-${svc}-confirmed`} /> Confirmado con el proveedor</label>
  );
  const xi = (k, props = {}) => (
    <Input value={x[k] ?? ""} onChange={(e) => setX({ ...x, [k]: props.type === "number" ? (e.target.value === "" ? null : Number(e.target.value)) : e.target.value })} data-testid={`ext-${k}`} {...props} />
  );

  return (
    <div className="space-y-4">
      <Section title="Catering" testid="catering" enabled={s.catering.enabled} onToggle={(v) => up("catering", "enabled", v)}>
        <Field label="Proveedor">{inp("catering", "provider")}</Field>
        <Field label="Precio por persona (€)">{inp("catering", "price_pp", { type: "number", step: "0.01" })}</Field>
        <Field label="Menú" className="md:col-span-2">{inp("catering", "menu")}</Field>
        <Field label="Intolerancias / necesidades" className="md:col-span-2">{inp("catering", "allergies")}</Field>
        {confirm("catering")}
      </Section>
      <Section title="Bebidas y barra" testid="drinks" enabled={s.drinks.enabled} onToggle={(v) => up("drinks", "enabled", v)}>
        <label className="flex items-center gap-2 text-sm"><Switch checked={!!s.drinks.open_bar} onCheckedChange={(v) => up("drinks", "open_bar", v)} data-testid="svc-drinks-open_bar" /> Barra libre</label>
        <Field label="Notas">{inp("drinks", "notes")}</Field>
      </Section>
      <Section title="DJ" testid="dj" enabled={s.dj.enabled} onToggle={(v) => up("dj", "enabled", v)}>
        <Field label="Proveedor / DJ">{inp("dj", "provider")}</Field>{confirm("dj")}
      </Section>
      <Section title="Decoración" testid="decor" enabled={s.decor.enabled} onToggle={(v) => up("decor", "enabled", v)}>
        <Field label="Detalle">{inp("decor", "notes")}</Field>{confirm("decor")}
      </Section>
      <Section title="Material y extras" testid="material">
        <Field label="Material necesario" className="md:col-span-2"><Textarea rows={2} value={s.material.notes} onChange={(e) => up("material", "notes", e.target.value)} data-testid="svc-material-notes" /></Field>
      </Section>
      {ev.kind === "externo" && (
        <Section title="Aura Eventos Externos" testid="external">
          <Field label="Dirección del evento" className="md:col-span-2">{xi("address")}</Field>
          <Field label="Hora de montaje">{xi("setup_time", { type: "time" })}</Field>
          <Field label="Hora de recogida">{xi("pickup_time", { type: "time" })}</Field>
          <Field label="Personal de transporte">{xi("transport_staff")}</Field>
          <Field label="Gastos de desplazamiento (€)">{xi("travel_cost", { type: "number", step: "0.01" })}</Field>
          <Field label="Material necesario" className="md:col-span-2">{xi("material")}</Field>
          <Field label="Fee conceptualización (€)">{xi("concept_fee", { type: "number", step: "0.01" })}</Field>
          <Field label="Fee coordinación (€)">{xi("coordination_fee", { type: "number", step: "0.01" })}</Field>
          <label className="flex items-center gap-2 text-sm"><Switch checked={!!x.coordination} onCheckedChange={(v) => setX({ ...x, coordination: v })} data-testid="ext-coordination" /> Coordinación contratada</label>
        </Section>
      )}
      <Button className={goldBtn} onClick={() => save({ services: s, external: x }, "Servicios guardados")} data-testid="svc-save">Guardar servicios</Button>
    </div>
  );
}
